module.exports = require('lodash').isNil